/* istanbul ignore file */
export const DEF_FILTER_DEBOUNCE_MS = 500;
export const DEFAULT_PAGE_SIZE = 20;
export const DELETED_DISTRIBUTION_LABEL = "Deleted distribution";
export const DELETED_TRANSACTION_LABEL = "Deleted transaction";
export const PAYMENT_REFERENCE_TOOLTIP_TEXT =
  "This unique ID is used to track payments. It is the IMAD/OMAD for wire transfers or the trace number for ACH payments.";
